import React, { useState } from 'react';
import { DogIcon } from 'lucide-react';
type WeightOption = {
  id: string;
  label: string;
  value: string;
};
export const WeightSelector = ({
  options,
  onSelect
}: {
  options: WeightOption[];
  onSelect: (value: string) => void;
}) => {
  const [selectedWeight, setSelectedWeight] = useState<string>(options[0].id);
  const handleSelect = (id: string) => {
    setSelectedWeight(id);
    const selectedOption = options.find(option => option.id === id);
    if (selectedOption) {
      onSelect(selectedOption.value);
    }
  };
  return <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12" data-id="element-357">
      {options.map(option => {
      const isSelected = selectedWeight === option.id;
      return <div key={option.id} onClick={() => handleSelect(option.id)} className={`
              rounded-lg p-5 cursor-pointer transition-all duration-300 transform
              ${isSelected ? 'bg-green-800 text-white shadow-lg -translate-y-1' : 'bg-green-100 text-green-800 shadow hover:shadow-md hover:-translate-y-0.5'}
            `} data-id="element-358">
            <div className="flex flex-col items-center text-center" data-id="element-359">
              <DogIcon className={`mb-2 ${isSelected ? 'text-white' : 'text-green-600'}`} size={24} data-id="element-360" />
              <h3 className="font-bold mb-2" data-id="element-361">{option.label}</h3>
              <p className="text-lg" data-id="element-362">{option.value}</p>
            </div>
          </div>;
    })}
    </div>;
};